<script>
export let rain;
</script>

<div>
    <span title="Rain accumulation">&#9926; {rain} kg/m<sup>2</sup></span>
</div>
